import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ActionService {
    /**
     * Get array of most up to date actions
     * @returns ActionBoInterface
     * @throws ApiError
     */
    static actionGetAll() {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/action',
        });
    }
    /**
     * Get action by id
     * @param actionId
     * @returns ActionBoInterface
     * @throws ApiError
     */
    static actionGetById(actionId) {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/action/{ActionId}',
            path: {
                'ActionId': actionId,
            },
        });
    }
    /**
     * Generate from an action type
     * @param actionType
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static actionGenerateAction(actionType, requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/action/generate/{actionType}',
            path: {
                'actionType': actionType,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
